export default __webpack_public_path__ + "static/media/marking--discrete--text.a473cb73.png";